import { render, staticRenderFns } from "./sertifika.vue?vue&type=template&id=16d90104"
import script from "./sertifika.vue?vue&type=script&lang=js"
export * from "./sertifika.vue?vue&type=script&lang=js"
import style0 from "./sertifika.vue?vue&type=style&index=0&id=16d90104&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports